import { useEffect, useState } from 'react';
import { COMMON_MOBILE_BREAKPOINT, useWindowWidth } from '@elfsight/lib-utils';
import type { PopupProps as PopupComponentProps } from '@elfsight/widget-modal';
import { Popup as PopupComponent } from '@elfsight/widget-modal';
import { useSettings } from '@wu/widget-core';

const THIN_MARGIN_BREAKPOINT = 640;
const DEFAULT_MARGIN: [number, number] = [40, 40];

export function Popup({
  children,
  show,
  onCloseRequest,
  ariaLabel
}: PopupComponentProps) {
  const { textColor, width, displayFreeLink } = useSettings();

  const windowWidth = useWindowWidth();

  const [margin, setMargin] = useState(DEFAULT_MARGIN);

  useEffect(() => {
    setMargin(windowWidth < THIN_MARGIN_BREAKPOINT ? [0, 20] : DEFAULT_MARGIN);
  }, [windowWidth]);

  return (
    <PopupComponent
      ariaLabel={ariaLabel}
      show={show}
      fixed
      disableScroll
      width={width.auto ? 'fit-content' : width.customValue}
      margin={margin}
      onCloseRequest={onCloseRequest}
      withBackdrop
      withCloseControl
      closeOnOutsideClick
      closeOnEscape
      closeControlColor={textColor}
      style={
        displayFreeLink
          ? { paddingBottom: windowWidth < COMMON_MOBILE_BREAKPOINT ? 50 : 30 }
          : {}
      }
    >
      {children}
    </PopupComponent>
  );
}
